module.exports = __webpack_public_path__ + "static/img/G1_V4.ac35196.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G1_V4.png
// module id = 7IAb
// module chunks = 1